/**
 * COPY BY URL PARAM
 */
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString)
const urltagElements = document.querySelectorAll('[class*=urltag_show]')

// When the parameter name and parameter value aren’t present in the url, 
// elements with the show class should be hidden, 
// and elements with the hide class should be shown. 
urltagElements.forEach(element => {
	element.style.display = 'none'
});

// Reverse the above for the parameter=value pairs present in the url
for(const [param, value] of urlParams.entries()) {
	const pattern = /^[.\w_-]*$/;
	const showClass = `urltag_show__${param}_${value}`;
	const hideClass = `urltag_hide__${param}_${value}`;
	
	// Testing for valid CSS class
	if (pattern.test(showClass)) {
		const elementsToShow = document.querySelectorAll('.' + showClass);
		elementsToShow.forEach(element => {
			element.style.display = 'block'
		});
	}

	if (pattern.test(hideClass)) {
		const elementsToHide = document.querySelectorAll('.' +  hideClass)
		elementsToHide.forEach(element => {
			element.style.display = 'none'
		});
	}
}
